module.exports = __webpack_public_path__ + "static/media/prov.ffab3dbd.jpg";